import { h } from 'preact';

import { Trans } from '@lingui/macro';

export const LocateMenu = () => (
	<a href={'#/locate'}><Trans>Map</Trans></a>
);
